<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.corporate") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="md"
            type="neutral"
            class="btn-primary"
            @click="handleCreate"
            >{{ $t("save") }}</base-button
          >
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("corp.create") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
<div class="form-group row">
              <label
                for="corporate-main"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("corporate_main") }}</label
              >
              <div class="col-md-10">
                <base-input>
                  <el-select id="corporate-main"
                    v-model="upperId"
                    filterable
                    :placeholder="$t('corporate_main')"
                  >
                    <el-option
                      v-for="option in corporate"
                      :key="option.ID"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="form-group row">
              <label for="corp-name" class="col-md-2 col-form-label form-control-label">{{
                $t("corp.name")
              }} *</label>
              <div class="col-md-10">
                <base-input id="corp-name" placeholder="" v-model="name"></base-input>
              </div>
            </div>

            <!--
              EAS dropdown only renders for a main corporate create.
              Sub-branches (upperId != 0) inherit the parent's EAS server,
              so the backend copies it across from the parent row.
            -->
            <div class="form-group row" v-if="!upperId">
              <label for="corp-eas-server" class="col-md-2 col-form-label form-control-label">{{
                $t("eas_server")
              }} *</label>
              <div class="col-md-10">
                <base-input>
                  <el-select id="corp-eas-server"
                    v-model="easServer"
                    :placeholder="$t('eas_server')"
                  >
                    <el-option
                      v-for="srv in easServers"
                      :key="srv.Name"
                      :label="
                        (srv.DisplayName || srv.Name) +
                          ' (' + srv.Used + '/' + srv.Capacity + ')'
                      "
                      :value="srv.Name"
                      :disabled="srv.Capacity > 0 && srv.Used >= srv.Capacity"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";
export default {
  name: "form-elements",
  components: {
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      inputs: {
        file: []
      },
      checkboxes: {
        unchecked: false,
        checked: true,
        uncheckedDisabled: false,
        checkedDisabled: true
      },
      radios: {
        radio1: "checked",
        radio2: "checked"
      },

      brn: "",
      name: "",
      code: "0",
      upperId: 0,
      easServer: ""
    };
  },
  computed: {
    ...mapGetters({
      corporate: "CorporateV4/getDataWithDefault",
      easServers: "Capacity/getData"
    })
  },
  mounted() {
    this.listData();
    this.listCapacity();
  },
  methods: {
    ...mapActions({
      createData: "CorporateV4/createData",
      listData: "CorporateV4/listData",
      listCapacity: "Capacity/listData"
    }),
    filesChange(files) {
      this.inputs.file = files;
    },
    handleCreate() {
      // EAS field is only required for a main-corporate create. For a
      // sub-branch (upperId != 0) the backend ignores easServer and copies
      // the parent's value.
      if (!this.upperId && !this.easServer) {
        swal.fire({
          title: this.$t("eas_server"),
          text: this.$t("errors.eas.required"),
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
        return;
      }
      this.createData({
        brn: this.brn,
        name: this.name,
        code: this.code,
        upperID: this.upperId,
        easServer: this.upperId ? "" : this.easServer
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("corp.create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              this.$router.push({ name: "corporate" });
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
